import { Transaction } from '../transactions/transaction';
import { Owner } from '../owner';
import { AllianceLockboxImportJob } from './alliance-lockbox-import-job';

export class AllianceLockboxTransaction
{
    documentId: string;
    managementCompanyId: number;
    associationId: string;
    associationName: string;
    memberId: string;
    altMemberId: string;
    memberName: string;
    transactionBatch: string;
    processDate: string;
    documentType: string;
    checkAmount: string;
    couponAmount: string;
    checkNumber: string;
    lockboxJobType: string;
    documentChannel: string;

    transaction: Transaction;
    payor: Owner;
    importJob: AllianceLockboxImportJob;

    constructor(ref) {
        this.documentId = ref.documentId;
        this.managementCompanyId = ref.managementCompanyId;
        this.associationId = ref.associationId;
        this.associationName = ref.associationName;
        this.memberId = ref.memberId;
        this.altMemberId = ref.altMemberId;
        this.memberName = ref.memberName;
        this.transactionBatch = ref.transactionBatch;
        this.processDate = ref.processDate;
        this.documentType = ref.documentType;
        this.checkAmount = ref.checkAmount;
        this.couponAmount = ref.couponAmount;
        this.checkNumber = ref.checkNumber;
        this.lockboxJobType = ref.lockboxJobType;
        this.documentChannel = ref.documentChannel;
        this.transaction = ref.transaction ? new Transaction(ref.transaction) : null;
        this.payor = ref.payor ? new Owner(ref.payor) : null;
        this.importJob = ref.importJob ? new AllianceLockboxImportJob(ref.importJob) : null;
    }
}
